import React from "react";
import { useNavigate } from "react-router-dom";
import DiscountForm from "../components/DiscountForm";
import "./FormPage.css";

const AddDiscount: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="form-page">
      {/* <div className="form-page-header">
        <h2>Add Discount</h2>
        <button className="ghost-btn" onClick={() => navigate(-1)}>
          Back
        </button>
      </div> */}
      <DiscountForm
        mode="create"
        submitLabel="Submit"
        initialValues={null}
        onSuccess={() => navigate("/discount/list")}
      />
    </div>
  );
};

export default AddDiscount;
